module.exports = __webpack_public_path__ + "static/media/29EUNOG17.37fe73c8.jpg";